import React, { useState } from "react";
import "./Dropdown.css";
import { Link } from "react-router-dom";

function Dropdown() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? "dropdown-menu-clicked" : "dropdown-menu"}
      >
        <li>
          <Link
            className="dropdown-link"
            to="/registration/student"
            onClick={() => setClick(false)}
          >
            As a Student
          </Link>
        </li>
        <li>
          <Link
            className="dropdown-link"
            to="/registration/employer"
            onClick={() => setClick(false)}
          >
            As an Employer
          </Link>
        </li>
      </ul>
    </>
  );
}

export default Dropdown;
